
export const regularCrystallisationContent = {
    summaryTitle: "Current Summary",
    amount: "Regular crystallisation amount",
    frequency: "Frequency of crystallisation",
    date: "Date of next payment",
    pcls: "Estimated PCLS",
    income: "Current regular income",
    annualIncome: "Annualised income",
    confirmationTitle:  "Confirmation",
    cancelButton: "Cancel regular crystallisation",
    lightboxMessage: "Are you sure you want to cancel the regular crystallisation?"
}

export const successMessage = (givenName: string, familyName: string) =>  `The regular crystallisation for ${givenName} ${familyName} is now cancelled.`;

